import QUERY_KEYS from '@/constants/query-keys';
import api from '@/lib/api';

interface SoCaiLenChoNhieuTaiKhoanResponse<T = any> {
  results: T[];
  count: number;
  next?: string | null;
}

export const fetchAllSoCaiLenChoNhieuTaiKhoan = async (
  entitySlug: string,
  body: Record<string, any> = {},
  pageSize = 200
): Promise<any[]> => {
  let page = 1;
  let all: any[] = [];
  let totalCount = 0;

  while (true) {
    const response = await api.post<SoCaiLenChoNhieuTaiKhoanResponse>(
      `/entities/${entitySlug}/erp/${QUERY_KEYS.SO_CAI_LEN_CHO_NHIEU_TAI_KHOAN}/`,
      body,
      {
        params: {
          page,
          page_size: pageSize
        }
      }
    );

    const pageResults = response.data.results || [];
    totalCount = response.data.count ?? totalCount;
    all = all.concat(pageResults);

    if (!pageResults.length) {
      break;
    }

    const hasNext = (response.data as any).next;

    if (!hasNext && pageResults.length < pageSize) {
      break;
    }

    if (totalCount && all.length >= totalCount) {
      break;
    }

    page += 1;
  }

  return all;
};
